import ApplicationSuccess from 'features/payOverTime/screens/application/ApplicationSuccess/ApplicationSuccess';
import React from 'react';

export default function Page() {
  return <ApplicationSuccess />;
}
